export enum MetadataDisplayType {
  NUMERIC_CHECKBOX_SELECTION = "NUMERIC_CHECKBOX_SELECTION",
  NUMERIC_SLIDER_SINGLE_SELECTION = "NUMERIC_SLIDER_SINGLE_SELECTION",
  NUMERIC_SLIDER_RANGE_SELECTION = "NUMERIC_SLIDER_RANGE_SELECTION",
  TEXT_CHECKBOX_SELECTION = "TEXT_CHECKBOX_SELECTION",
  TEXT_SLIDER_SINGLE_SELECTION = "TEXT_SLIDER_SINGLE_SELECTION",
  TEXT_SLIDER_RANGE_SELECTION = "TEXT_SLIDER_RANGE_SELECTION",
  TEXT_RADIOBUTTON_SELECTION = "TEXT_RADIOBUTTON_SELECTION"
}